core.constant('availabilityMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "ENUM": {
        "DAY_TYPE": {
          "DAY" : "Dzień",
          "WEEKDAY" : "Dzień tygodnia",
          "WEEKEND" : "Weekend",
          "MONDAY" : "Poniedziałek",
          "TUESDAY" : "Wtorek",
          "WEDNESDAY" : "Środa",
          "THURSDAY" : "Czwartek",
          "FRIDAY" : "Piątek",
          "SATURDAY" : "Sobota",
          "SUNDAY" : "Niedziela"
        },
        "DAY_TYPE_SHORT": {
          "MONDAY" : "Pn",
          "TUESDAY" : "Wt",
          "WEDNESDAY" : "Śr",
          "THURSDAY" : "Czw",
          "FRIDAY" : "Pt",
          "SATURDAY" : "Sb",
          "SUNDAY" : "Ndz"
        }
      },
      "UI": {
        "TAB": {
        },
        "BUTTON": {
          "ADD_NEW_VACATION" : "Dodaj nowy urlop",
          "ADD_NEW_PLAN" : "Dodaj nowy plan"
        },
        "BREADCRUMB": {
        },
        "APPLICATION" : {
          "AVAILABILITY" : "Dostępność"
        },
        "AVAILABILITY_LEGEND" : {
          "STATIONARY_VISIT" : "Wizyta stacjonarna",
          "TRIP_CITY" : "Wizyta wyjazdowa miasto",
          "TRIP_CITY_FAR" : "Wizyta wyjazdowa miasto +30 km",
          "VIDEO_CONSULTATION" : "Konsultacja online"
        }
      },
      "MODULE": {
        "TITLE": {
          "VACATIONS" : "Urlopy",
          "LEGEND" : "Legenda",
          "AVAILABILITY_HOURS" : "Godziny przyjęć",
          "FROM" : "Od"
        },
        "VACATION" : {
          "NEW_VACATION" : "Dodaj nowy urlop"
        },
        "TOOLTIP" : {
          "STATIONARY_VISIT" : "Wizyta stacjonarna",
          "TRIP_CITY" : "Wizyta wyjazdowa miasto",
          "TRIP_CITY_FAR" : "Wizyta wyjazdowa miasto +30 km",
          "VIDEO_CONSULTATION" : "Konsultacja online"
        },
        "AVAILABILITY": {
          "SAVE_AVAILABILITY_CONFIRMATION_MESSAGE" : "Czy na pewno chcesz zapisać daną dostępność? Będzie ona kolidowała z następującymi terminami:",
          "SAVE_VACATION_CONFIRMATION_MESSAGE" : "Czy na pewno chcesz zapisać dany urlop? Będzie on kolidował z następującymi terminami:",
          "CANNOT_ADD_MORE_AVAILABILITY" : "Masz już dodane nadchodzące reguły dostępności. Usuń nadchodzące reguły, by móc dodać nowe dostępności.",
          "START_DATE" : "Czas zobowiązywania od daty",
          "NEW_AVAILABILITY" : "Dodaj dostępność",
          "EDIT_AVAILABILITY" : "Edytuj dostępność",
          "OFFICE_HOURS" : "Godziny przyjęć",
          "FROM" : "Od",
          "TO" : "Do",
          "AVAILABILITY_DELETE_CONFIRMATION" : "Czy chcesz usunąć dostępność?",
          "VACATION_DELETE_CONFIRMATION" : "Czy chcesz usunąć urlop?",
          "NO_AVAILABLE_RULES" : "Aktualnie w tym gabinecie nie masz zdefiniowanych żadnych planów.",
          "DATE_SCOPE": "Zakres zobowiązywania"
        }
      }
    }
  }
});
